exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".desc[data-v-529a40e1]{font-size:.16rem;font-weight:400;color:rgba(0,0,0,.5);line-height:.24rem;margin-top:.16rem}.num[data-v-529a40e1]{font-size:.28rem;font-weight:500;color:#1f1f1f}.notReceived[data-v-529a40e1]{font-size:.22rem;font-weight:500;color:rgba(0,0,0,.85);line-height:.32rem}.notReceived i[data-v-529a40e1]{font-size:.24rem;color:#faad14;margin-right:.12rem}", ""]);

// exports
